module.exports = __webpack_public_path__ + "img/afther-4.5ae11aa1.png";